<template>
	<div class="newsletter" :class="where">
		<h3>Newsletter</h3>
		<p>Subscribe to stay informed about upcoming events and news about tracking.</p>
		<div v-if="!success">
			<input type="text" value="" v-model="name" name="NAME" placeholder="Name">
			<input type="email" value="" v-model="email" name="EMAIL" placeholder="Email">
			<button class="normal" :disabled="!emailValid || subscribing" @click="subscribe">{{ button }}</button>
		</div>
		<div v-else class="success">
			{{ response }}
		</div>
		<p class="link"><router-link to="/newsletter" title="View previous campaigns">View previous newsletters<img class="arrow" width="18px" src="https://s3.eu-central-1.amazonaws.com/tractrac/web/long-arrow-alt-right-regular.svg" alt="Arrow Icon" /></router-link></p>
		<div v-html="archive"></div>
	</div>
</template>

<script>

export default {
	name: 'Newsletter',
	props: ['where'],
	data () {
		return {
			publicPath: process.env.BASE_URL,
			email: '',
			name: '',
			response: '',
			subscribing: false,
			success: false,
			button: 'Subscribe',
			archive: ''
		}
	},
	created () {
		if (this.where === 'page') {
			this.$http.get('https://www.tractrac.com/json/newsarchive.php').then((response) => {
				this.archive = response.data.replace('document.write("', '').replace('");', '').replace(/\\/g, '')
			})
		}
	},
	methods: {
		subscribe () {
			if ((this.name.length === 0 && this.email.length !== 0) || !this.subscribing) {
				this.subscribing = true
				this.button = 'Subscribing'
				this.$http.post('https://www.tractrac.com/json/subscribe.php', {
					email: this.email,
					name: this.name
				}, { emulateJSON: true }).then((response) => {
					if (response.status === 200) {
						let body = JSON.parse(response.body)
						if (body.result === 'success') {
							this.email = ''
							this.name = ''
							this.success = body.result === 'success'
							this.response = body.msg
						}
					}
					this.subscribing = false
					this.button = 'Subscribe'
				})
			}
		}
	},
	computed: {
		emailValid () {
			return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)
		}
	}
}

</script>

<style scoped lang="scss">

$link: #333;
$hover: #e74c3c;
$blueDark: rgba(0, 90, 132, 1);
$blueLight: rgba(0, 159, 194, 1);
$green: #63b323;
$grey: #9D9D9D;

.newsletter input[type=text] {
	z-index: -5;
	position: absolute;
}

.newsletter input[type=email],
.newsletter input[type=text] {
	width: 320px;
	margin-bottom: 12px;
}

.newsletter.page input[type=email],
.newsletter.page input[type=text] {
	background: #efefef;
	border: none;
}

.newsletter .success {
	color: $green;
}

.newsletter.side h3 {
	font-size: 18px;
	margin: 0 0 16px 0;
	font-weight: 500;
	color: #333;
}

.newsletter.side p {
	font-size: 14px;
	line-height: 24px;
	color: #9D9D9D;
	font-weight: 300;
}

.newsletter p img {
	vertical-align: middle;
	margin-left: 12px;
}

.newsletter.page p.link {
	display: none;
}

.newsletter p a {
	color: $link;
	text-decoration: none;
}

.newsletter p a:hover {
	color: $hover;
}

.newsletter.page div .display_archive {
	margin-top: 32px;
}

.newsletter.page div .display_archive .campaign {
	margin-bottom: 8px;
	color: #666666;
	font-size: 14px;
}

.newsletter.page div .display_archive .campaign a {
	color: $link;
}

.newsletter.page div .display_archive .campaign a:hover {
	color: $hover;
}

</style>

<style lang="scss">

$link: #333;
$hover: #e74c3c;
$blueDark: rgba(0, 90, 132, 1);
$blueLight: rgba(0, 159, 194, 1);
$green: #63b323;
$grey: #9D9D9D;

.display_archive {
	margin-top: 32px;
}

.display_archive .campaign {
	margin-bottom: 8px;
	color: #666666;
	font-size: 14px;
}

.display_archive .campaign a {
	color: $link;
}

.display_archive .campaign a:hover {
	color: $hover;
}

</style>
